/*===========================================
Template Name: Edulyn - React Education Template
Author: Md Tahmidur Rahman
Author URL: http://snazzytheme.com/
Version: 1.0
==============================================*/

import { createGlobalStyle } from "styled-components";
import { colors, fonts } from "../element/elements.js";

export const GlobalStyle = createGlobalStyle`
    html {
        color      : ${colors.bg1};
        font-size  : 13px;
        line-height: 1.4;
    }

    ::-moz-selection {
        background : #b3d4fc;
        text-shadow: none;
    }

    ::selection {
        background : #b3d4fc;
        text-shadow: none;
    }

    hr {
        display   : block;
        height    : 1px;
        border    : 0;
        border-top: 1px solid ${colors.border3};
        margin    : 1em 0;
        padding   : 0;
    }

    audio,
    canvas,
    iframe,
    img,
    svg,
    video {
        vertical-align: middle;
    }

    fieldset {
        border : 0;
        margin : 0;
        padding: 0;
    }

    textarea {
        resize: vertical;
    }

    body {
        font-size     : 13px;
        background    : #ffffff;
        color         : ${colors.text1};
        letter-spacing: 0.3px;
        font-family   : ${fonts.roboto};
    }

    h1,
    h1 a {
        font-size: 40px;
    }

    h2,
    h2 a {
        font-size: 32px;
    }

    h3,
    h3 a {
        font-size: 28px;
    }

    h4,
    h4 a {
        font-size: 24px;
    }

    h5,
    h5 a {
        font-size: 20px;
    }

    h6,
    h6 a {
        font-size: 16px;
    }

    h1,
    h1 a,
    h2,
    h2 a,
    h3,
    h3 a,
    h4,
    h4 a,
    h5,
    h5 a,
    h6,
    h6 a {
        font-family: ${fonts.poppins};
        margin     : 0;
    }

    a,
    button,
    li,
    p {
        font-size     : 13px;
        font-family   : ${fonts.roboto};
        margin        : 0;
        letter-spacing: 0.3px;
    }

    ul {
        padding: 0;
        margin : 0;
    }

    a,
    a:active,
    a:focus,
    a:hover,
    button:focus,
    button:hover {
        text-decoration: none;
        outline        : none;
    }

    a,
    button {
        transition: all 0.2s ease;
    }

    input:focus,
    textarea:focus {
        outline: none;
    }

    .padding-fix {
        padding-left : 0;
        padding-right: 0;
    }

    .padding-fix-r {
        padding-right: 0;
    }

    .padding-fix-l {
        padding-left: 0;
    }

    .margin-fix {
        margin-left : 0;
        margin-right: 0;
    }

    .container,
    .container-sm,
    .container-md,
    .container-lg,
    .container-xl {
        max-width: 1440px;
    }

    body.sidebar-pinned {
        overflow-x: hidden;
    }

    body.sidebar-pinned #root {
        margin-left: 250px;
        transition: margin 0.3s ease;
    }

    @media (max-width: 991px) {
    body.sidebar-pinned #root {
        margin-left: 0;
    }
    }

    .global-loading-overlay {
        position: fixed;
        inset: 0;
        background: rgba(24, 43, 73, 0.35);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10500;
    }

    .global-loading-overlay .loading-indicator {
        background: rgba(255, 255, 255, 0.95);
        padding: 18px 28px;
        border-radius: 10px;
        box-shadow: 0 18px 45px rgba(24, 43, 73, 0.18);
        display: flex;
        align-items: center;
        gap: 14px;
        min-width: 180px;
        justify-content: center;
        border: 1px solid ${colors.border1};
    }

    .global-loading-overlay .loading-spinner {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 2px solid ${colors.red};
        border-top-color: transparent;
        animation: global-loader-spin 0.8s linear infinite;
    }

    .global-loading-overlay .loading-text {
        font-size: 14px;
        font-weight: 600;
        color: ${colors.black1};
        letter-spacing: 0.05em;
    }

    @keyframes global-loader-spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
